module.exports = __webpack_public_path__ + "static/media/abbvie.b9e4c814.svg";